import * as React from "react";
import Box from "@mui/material/Box";
import Selection from "./Selection";
import { useECSContext } from "../../ecsContext";

export default function EquipmentSelection() {
  const {
    ecsList,
    setEcsList,
    selectedListRow,
    setSelectedListRow,
    tagMaterials,
  } = useECSContext();

  const onChangeTag = (event) => {
    const selected = ecsList.find((e) => e.tagNumber === event.target.value);
    setSelectedListRow(selected);
  };

  const onChangeDesc = (event) => {
    const selected = ecsList.find((e) => e.description === event.target.value);
    setSelectedListRow(selected);
  };

  console.log("selectedListRow", selectedListRow);
  return (
    <Box sx={{ display: "flex", gap: 2, ml: 2 }}>
      <Box sx={{ minWidth: 300, maxWidth: 400 }}>
        <Selection
          label="Tag #"
          value={selectedListRow?.tagNumber || ""}
          onChange={onChangeTag}
          options={ecsList.map((e) => e.tagNumber)}
        />
      </Box>
      <Box sx={{ minWidth: 500, maxWidth: 600 }}>
        <Selection
          label="Description"
          value={selectedListRow?.description || ""}
          onChange={onChangeDesc}
          options={ecsList.map((e) => e.description)}
        />
      </Box>
    </Box>
  );
}
